<template>
  <div>
    <router-link
      target="_blank"
      class="trastdybtn csst mdi mdi-school icon_btn text-semi-large pa-2 text-nowrap"
      :to="studyLink"
    >
      <div
        class="csst_content clr-white"
        style="position: fixed; margin-top: -4.5rem"
      >
        {{ $t(`tooltips.study_spot`) }}
      </div>
    </router-link>
  </div>
</template>

<script>
import links_mix from '@/mixins/links_mix'

export default {
  name: 'TrainerStudySpotBtn',
  mixins: [links_mix],
  props: {
    namespace: { type: String, required: true },
  },
  data() {
    return {}
  },
  computed: {
    studyLink() {
      const res = this.links_getLink({
        pathName: 'StudySolutions',
        hasTmpBoard: true,
        asRouterLink: true,
        namespace: this.namespace,
        query: { soltab: 'strategy' },
      })
      // console.log(res, this.namespace)
      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.trastdybtn {
  color: var(--clr-grey-2);
  &:hover {
    color: var(--clr-white-0);
  }
}
</style>
